export const GET_INITIAL_OPTIONS = () => [
  {
    title: '',
    isAnswer: false,
  },
  {
    title: '',
    isAnswer: false,
  },
  {
    title: '',
    isAnswer: false,
  },
  {
    title: '',
    isAnswer: false,
  },
];

export const GET_INITIAL_TWO_OPTIONS = () => [
  {
    title: '',
    isAnswer: false,
  },
  {
    title: '',
    isAnswer: false,
  },
];
